import { OnePagerReport } from "./OnePagerReport";

export default OnePagerReport;
